module.exports = __webpack_public_path__ + "img/how_to_join_1.8feae162.webp";